module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-300.a6871adb9a110c4c660d.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-300.woff
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-300.woff
// module chunks = styles